import type { Category } from '@/types';

export const categories: Category[] = [
  {
    id: 'movie',
    name: '电影',
    icon: 'ri-film-line',
    description: '院线新片、口碑佳作与经典重映',
    accent: 'primary',
  },
  {
    id: 'tv',
    name: '电视剧',
    icon: 'ri-tv-2-line',
    description: '热播剧集、海外剧与精品短剧',
    accent: 'accent',
  },
  {
    id: 'variety',
    name: '综艺',
    icon: 'ri-mic-2-line',
    description: '真人秀、音乐竞演与脱口秀',
    accent: 'secondary',
  },
  {
    id: 'documentary',
    name: '纪录片',
    icon: 'ri-camera-lens-line',
    description: '自然、人文与历史纪实影像',
    accent: 'primary',
  },
  {
    id: 'anime',
    name: '动漫',
    icon: 'ri-bear-smile-line',
    description: '国漫新番、日番续作与剧场版',
    accent: 'accent',
  },
  {
    id: 'short',
    name: '短片',
    icon: 'ri-clapperboard-line',
    description: '实验短片、创投导演与节展获奖作品',
    accent: 'secondary',
  },
];

/** 分类页侧栏使用的筛选维度 */
export const genreOptions = [
  '剧情', '科幻', '悬疑', '喜剧', '动作', '爱情', '动画', '纪实', '犯罪', '冒险',
];

export const regionOptions = [
  '中国大陆', '中国香港', '美国', '日本', '韩国', '英国', '法国',
];

export const yearOptions = ['2026', '2025', '2024', '2023', '2022'];

export const sortOptions = [
  { label: '最新上线', value: 'latest' },
  { label: '最热门', value: 'hot' },
  { label: '评分最高', value: 'score' },
];